import { PropsWithChildren } from 'react';
import {
  ContentWithFooterContainer,
  ContentWithFooterContent,
  ContentWithFooterFooter,
} from './content-with-footer.style';

interface ContentWithFooterContainerProps extends PropsWithChildren {
  footer: React.ReactNode;
}

export const ContentWithFooterLayout: React.FC<ContentWithFooterContainerProps> = ({
  children,
  footer,
}) => (
  <ContentWithFooterContainer>
    <ContentWithFooterContent>{children}</ContentWithFooterContent>
    <ContentWithFooterFooter>{footer}</ContentWithFooterFooter>
  </ContentWithFooterContainer>
);
